
export const environment = {
    production: false,
    apiUrl: 'https://demo.fbspickem.com/api/v1',
};
